export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
// export const KEY = 'c756c5d4-3b08-4353-ae50-396917066ee2';
// export const KEY = '76e17fd0-598f-41f1-977b-f6a91c6ff3b6';
export const KEY = '60580620-4200-45b6-bd4f-601462b94bd4';
export const MODAL_CLOSE_SEC = 2;
